import React from 'react'

import { createCSV } from 'Store/encounters'
import { colors } from 'Constants'
import { toast } from 'react-toastify'

import { Button } from 'Components/shared/Button'
import { Text } from 'Components/shared/Typography'

export default ({ sortingParams, filteringParams, searchParams, headingParams }) => {
  const getHeading = heading => {
    let headingText

    if (heading.type === 'Date Range') {
      const fromDateIdx = searchParams.searchParam.keys.indexOf('From Date')
      const toDateIdx = searchParams.searchParam.keys.indexOf('To Date')

      const today = new Date()

      let fromDate = today
      fromDate.setMonth(fromDate.getMonth() - 1)
      if (fromDateIdx !== -1) fromDate = new Date(searchParams.searchParam.values[fromDateIdx])

      let toDate = today
      if (toDateIdx !== -1) toDate = new Date(searchParams.searchParam.values[toDateIdx])

      const dateRangeItems = [
        'Date Range',
        `${fromDate.getMonth() + 1}/${fromDate.getDate()}/${fromDate.getFullYear()}`,
        `${toDate.getMonth() + 1}/${toDate.getDate()}/${toDate.getFullYear()}`
      ]
      headingText = dateRangeItems.join(',')
    } else {
      const headingItems = [heading.type, heading.data]
      headingText = headingItems.join(',')
    }

    return headingText
  }

  return (
    <Button
      color={colors.blue}
      onClick={async e => {
        e.preventDefault()
        toast.info('Your report is being generated...\nThis could take a couple of minutes.')
        const heading = getHeading(headingParams)
        await createCSV({ sortingParams, filteringParams, searchParams, heading })
      }}
    >
      <Text color="#fff">Export</Text>
    </Button>
  )
}
